/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { provider_reference } from '../../domain/provider_reference';
import { amount } from '../../ehr/subs/amount';
import { diagnosisreference } from '../../ehr/subs/diagnosisreference';
import { referenceidentification } from '../../ehr/subs/referenceidentification';
import { referralreference } from '../../ehr/subs/referralreference';
import { relatedcause } from '../../ehr/subs/relatedcause';
import { requestvalidation } from '../../ehr/subs/requestvalidation';
import { servicedate } from '../../ehr/subs/servicedate';
import { subscriberreference } from '../../ehr/subs/subscriberreference';
import { IceTypes } from "../../icetypes";
import { claim } from './claim';
import { claimambulance } from './claimambulance';
import { claimcontract } from './claimcontract';
import { claimnote } from './claimnote';
import { claimsupplementalinformation } from './claimsupplementalinformation';

export class claimbucket extends IceEntity {
  claim_bucket_key: string = "";
  superbill_charges_key: string = "";
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  to_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  to_trans_account: string = "";
  billing_provider_trans_account: string = "";
  billing_provider_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  payto_trans_account: string = "";
  payto_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  trans_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  claim_to: string = "";
  claim_from: string = "";
  report_type_code: string = "";
  report_transmission_code: string = "";
  report_identification_code_qualifier: string = "";
  report_identification_code: string = "";
  transaction_purpose_code: string = "";
  insurance_type_code: string = "";
  claim_filing_indicator_code: string = "";
  claim_format_type: string = "";
  claim_encounter_type: string = "";
  claim_media_type: IceTypes.claim_media_types = IceTypes.claim_media_types.cmtECS;
  place_of_service_code: string = "";
  facility_code_qualifier: string = "";
  provider_accepts_assignment_code: string = "";
  assignment_of_benefits_code: string = "";
  provider_signature_code: string = "";
  patient_signature_code: string = "";
  release_of_information_code: string = "";
  total_claim_charge_amount: number = 0;
  last_message_key: string = "";
  last_message_date: any = NaN;
  last_message_log: string = "";
  last_message_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  last_response_message_key: string = "";
  last_response_message_date: any = NaN;
  last_response_message_log: string = "";
  last_response_message_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  draft_message_key: string = "";;
  draft_message_date: any = NaN;
  draft_message_log: string = "";;
  draft_message_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  connection_parameters_key: string = "";;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  DIAGS: diagnosisreference[] = [];
  CAUSES: relatedcause[] = [];
  SVCDTS: servicedate[] = [];
  REFLREFS: referralreference[] = [];
  COBS: amount[] = [];
  PROS: provider_reference[] = [];
  AMBS: claimambulance[] = [];
  CNTRCS: claimcontract[] = [];
  CLMNOTES: claimnote[] = [];
  SUPPL: claimsupplementalinformation[] = [];
  SUBS: subscriberreference[] = [];
  REFIDS: referenceidentification[] = [];
  CLMS: claim[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_BUCKET";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DIAGS") return true;
    else if (ColumnName == "CAUSES") return true;
    else if (ColumnName == "SVCDTS") return true;
    else if (ColumnName == "REFLREFS") return true;
    else if (ColumnName == "COBS") return true;
    else if (ColumnName == "PROS") return true;
    else if (ColumnName == "AMBS") return true;
    else if (ColumnName == "CNTRCS") return true;
    else if (ColumnName == "CLMNOTES") return true;
    else if (ColumnName == "SUPPL") return true;
    else if (ColumnName == "SUBS") return true;
    else if (ColumnName == "REFIDS") return true;
    else if (ColumnName == "CLMS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DIAGS") return "DIAGNOSIS_REFERENCE";
    else if (ColumnName == "CAUSES") return "RELATED_CAUSE";
    else if (ColumnName == "SVCDTS") return "SERVICE_DATE";
    else if (ColumnName == "REFLREFS") return "REFERRAL_REFERENCE";
    else if (ColumnName == "COBS") return "AMOUNT";
    else if (ColumnName == "PROS") return "PROVIDER_REFERENCE";
    else if (ColumnName == "AMBS") return "CLAIM_AMBULANCE";
    else if (ColumnName == "CNTRCS") return "CLAIM_CONTRACT";
    else if (ColumnName == "CLMNOTES") return "CLAIM_NOTE";
    else if (ColumnName == "SUPPL") return "CLAIM_SUPPLEMENTAL_INFORMATION";
    else if (ColumnName == "SUBS") return "SUBSCRIBER_REFERENCE";
    else if (ColumnName == "REFIDS") return "REFERENCE_IDENTIFICATION";
    else if (ColumnName == "CLMS") return "CLAIM";

    return null;
  }
}
